import { createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
import {
  IDocument,
  IDocument2,
  IDocumentResponse,
  IDocumentType,
} from "src/common/typings/s3-file-metadata";
import { AppMessages } from "src/common/utils/app.messages";

export const getOrderStatusAction = createAsyncThunk(
  "workorder/getOrderStatusAction",
  async (_az, { dispatch }): Promise<any> => {
    try {
      const res = await ax.get<IApi & { statusOrders: any }>("/get-status-orders/VendorPortal", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.status === 200 && res.data.success) {
        return res.data.statusOrders;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
      throw error;
    }
  }
);

export const handleOrderStatus = (state: any, { payload }: PayloadAction<any>) => {
  state.status = "idle";
  state.orderStatus = payload;
};

export const getDocumentPreSignedURL = createAsyncThunk(
  "workorder/getDocumentPreSignedURL",
  async (formData: IDocument, { dispatch }): Promise<IDocumentResponse> => {
    try {
      const res = await ax.post<IApi & IDocumentResponse>(
        "/get-document-pre-signed-url-vendor-portal",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200 && res.data.success) {
        return res.data;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: AppMessages.get(error.message) || error.message,
          options: { variant: "error" },
        })
      );
      throw error;
    }
  }
);

export const getDocumentPreSignedURLForVendor = createAsyncThunk(
  "workorder/getDocumentPreSignedURLForVendor",
  async (formData: IDocument2, { dispatch }): Promise<IDocumentResponse> => {
    try {
      const res = await ax.post<IApi & IDocumentResponse>(
        "/get-document-pre-signed-url-by-vendor",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200 && res.data.success) {
        return res.data;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: AppMessages.get(error.message) || error.message,
          options: { variant: "error" },
        })
      );
      throw error;
    }
  }
);

export const uploadDocument = createAsyncThunk(
  "workorder/uploadDocument",
  async (
    {
      url,
      formData,
      contentType,
      size,
      mgsNotShown,
      includedEncoding = false,
      cusMessage,
    }: { url: string; formData: File; contentType: string; size: number; mgsNotShown?: boolean; includedEncoding?: boolean,cusMessage?:string },
    { dispatch }
  ): Promise<boolean> => {
    try {
      const headers: any = {
        "Content-Type": contentType,
        "Content-Length": size,
      };
      if (includedEncoding) {
        headers["x-amz-server-side-encryption"] = "AES256";
        headers["x-amz-tagging"]= "classification=confidential";
      }
      const res = await axios.put(url, formData, { headers });
      if (res.status === 200) {
        const message = "Document Uploaded Successfully!";
        if (!mgsNotShown) {
          dispatch(
            addNotificationAction({
              message: message,
              options: { variant: "success" },
            })
          );
        }

        return true;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: cusMessage? cusMessage : AppMessages.get(error.message) || error.message,
          options: { variant: "error" },
        })
      );
      throw error;
    }
  }
);
// get Doc types

export const getDocumentTypesAction = createAsyncThunk(
  "workorder/getDocumentTypesAction",
  async (type: string, { dispatch }): Promise<IDocumentType> => {
    try {
      const res = await ax.get<IApi & IDocumentType>(`/get-document-type/${type}`);
      if (res.status === 200 && res.data.success) {
        return res.data;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: AppMessages.get(error.message) || error.message,
          options: { variant: "error" },
        })
      );
      throw error;
    }
  }
);
